exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-container-2Z43j{padding:5px 10px;width:fit-content;background-color:var(--bg);color:var(--color);text-align:center;font-size:11px;font-weight:500;line-height:100%;border-radius:28px;letter-spacing:.11px;--color:var(--color-night-gray8,#32435e)}.style-cssmodule-container-2Z43j[data-status=ACTIVE]{--color:var(--color-green-dark,#019941);--bg:var(--color-green-lighter,#dff3e7)}.style-cssmodule-container-2Z43j[data-status=INACTIVE]{--color:var(--color-orange-normal,#f77706);--bg:var(--color-orange-lighter,#fdf2e9)}.style-cssmodule-container-2Z43j[data-status=ARCHIVED],.style-cssmodule-container-2Z43j[data-status=PENDING]{--color:var(--color-blue-gray-dark,#5f72ab);--bg:var(--color-blue-gray-lighter,#f2f4fa)}", ""]);

// exports
exports.locals = {
	"container": "style-cssmodule-container-2Z43j"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/accounts/components/Status/style.cssmodule.css
// module id = 2551
// module chunks = 121